import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePage } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { PageHero, CTABand, usePageTitle } from "@/components/site/Bits";

export default function Servicos() {
  usePageTitle("Serviços Jurídicos");
  const { sections: s } = usePage("servicos");
  const items = Array.isArray(s.items) ? s.items : [];

  return (
    <>
      <PageHero title={s.hero_title || "Serviços Jurídicos"} text={s.hero_text} overline="Silva Cotan e Associados — Assessoria Jurídica" />

      <section className="bg-ivory">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          {items.map((item, i) => (
            <Reveal key={i} delay={0.04 * i}>
              <div className="grid gap-6 border-t border-navy/10 py-10 md:grid-cols-[110px_1fr_1.4fr] md:gap-12 md:py-14" data-testid={`servico-row-${i}`}>
                <span className="font-display text-4xl italic text-gold md:text-5xl">0{i + 1}</span>
                <h2 className="font-display text-2xl leading-snug text-navy md:text-3xl">{item.title}</h2>
                <div>
                  <p className="text-base leading-relaxed text-inkgray">{item.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-navy/10" />
        </div>
      </section>

      <section className="bg-paper">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 py-16 md:flex-row md:items-center md:px-8 md:py-20">
          <Reveal>
            <div>
              <h2 className="font-display text-2xl text-navy md:text-3xl">{s.closing_title || "Precisa de suporte?"}</h2>
              <p className="mt-3 max-w-xl text-sm text-inkgray md:text-base">{s.closing_text}</p>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <Link
              to="/contato"
              data-testid="servicos-cta-button"
              className="group inline-flex items-center gap-3 bg-navy px-7 py-4 text-[11px] font-bold uppercase tracking-[0.22em] text-ivory transition-colors hover:bg-navy-2"
            >
              Entrar em contato
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>

      <CTABand title="Suporte jurídico conforme a sua necessidade." button="Fale conosco" />
    </>
  );
}
